import React from 'react'
import theme from '@modul-connect/shared/theme'
import View from '../view'

const Tag = ({
  value,
  tagColor,
  textColor,
  extend
}) => {

  return (
    <View
      extend={{
        display: 'flex',
        backgroundColor: (
          tagColor && theme.colors.tag[tagColor.toLowerCase()] ? 
            theme.colors.tag[tagColor.toLowerCase()] : theme.colors.disabledGrey
        ),
        color: textColor ?? theme.colors.white,
        textAlign: 'center',
        alignItems: 'center',
        fontSize: 10,
        height: 18,
        textTransform: 'Uppercase',
        padding: '2px 4px',
        borderRadius: 4,
        whiteSpace: 'nowrap',
        ...extend
      }}
    >
      {value}
    </View>
  )
}

export default Tag
